// Path constants for investors module endpoints.
//
// Centralised here so endpoint functions in `investorsEndpoints.ts` and
// `vaspEndpoints.ts` reference one source of truth rather than hand-rolling
// each path string. Any backend prefix rename (e.g. `/api/admin/` →
// `/api/v2/admin/`) is now a single-file edit.

export const INVESTORS = '/api/admin/investors'
export const BANK_ACCOUNTS = '/api/admin/investors/bank-accounts'
export const COMPLIANCE_KYC = '/api/admin/compliance/investors/kyc'
export const ONBOARDING_PIPELINE = '/api/admin/onboarding/pipeline'
export const VASP_INVESTORS = '/api/vasp/investor-users'
export const VASP_INVESTOR_USERS_DETAILS = '/api/vasp/investor-users-details'
